module.exports = __webpack_public_path__ + "media/parents/early-college-planning-407d18b4.svg";